import React from "react";

const GeminiIcon = ({ variant = "dark" }) => {
  const fillClass = variant === "light" 
    ? "group-hover:fill-gray-200 fill-white" 
    : "group-hover:fill-[#262626] fill-[#595959]";

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      role="presentation"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 24A14.304 14.304 0 000 12 14.304 14.304 0 0012 0a14.305 14.305 0 0012 12 14.305 14.305 0 00-12 12"
        className={fillClass}
      />
    </svg>
  );
};

export default GeminiIcon; 